import { useCallback, useState } from "react";

import { useEventListener } from "usehooks-ts";

type Options = {
  defaultCursor?: number;
  min?: number;
  max?: number;
  onEnter?: (_event: KeyboardEvent) => void;
};

const useArrowKeys = ({
  defaultCursor,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  onEnter,
}: Options = {}) => {
  const [cursor, setCursor] = useState<number>(
    (typeof defaultCursor !== undefined ? defaultCursor : min - 1) || -1
  );

  const onKeydown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "ArrowDown") {
        if (cursor < max) {
          setCursor(cursor + 1);
        }
      } else if (event.key === "ArrowUp") {
        if (cursor >= min) {
          setCursor(cursor - 1);
        }
      } else if (event.key === "Enter") {
        if (onEnter) {
          onEnter(event);
        }
      }
    },
    [cursor, max, min, onEnter]
  );

  useEventListener("keydown", onKeydown);

  return { cursor, setCursor };
};

export default useArrowKeys;
